import {
  OktaAuth,
  AuthState,
  OktaAuthCoreInterface,
  OktaAuthOptions,
} from '@okta/okta-auth-js';

const SCOPES = ['offline_access', 'openid', 'profile', 'email'];

export interface OktaConfigurtionOptions {
  issuer: string;
  clientId: string;
  postLogoutRedirectUri: string;
  postLoginRedirectUri: string;
  transformAuthState?: (
    oktaAuth: OktaAuthCoreInterface,
    authState: AuthState,
  ) => Promise<AuthState>;
}

export const OKTA_REDIRECT_URI = window.location.origin;
export const CONFIG = (options: OktaConfigurtionOptions): OktaAuthOptions => ({
  issuer: options.issuer,
  clientId: options.clientId,
  redirectUri: options.postLoginRedirectUri,
  scopes: SCOPES,
  pkce: true,
  tokenManager: {
    autoRenew: false,
    autoRemove: false,
  },
  postLogoutRedirectUri: options.postLogoutRedirectUri,
  transformAuthState: options.transformAuthState,
});

let okta: OktaAuth | null = null;

export const setOkta = (auth: OktaAuth | null): void => {
  okta = auth;
};

export const getOkta = (): OktaAuth | null => {
  return okta;
};
